import { Chip } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import React, { Fragment } from "react";

function ReadFormatter({row}) {
  return (
    <Fragment>
      <Chip
        className={row.IsRead ? "success" : "danger"}
        label={
            row.IsRead ? <Translator id="read" /> : <Translator id="unread" />
        }
      />
    </Fragment>
  );
}

export default ReadFormatter;
